import React from 'react';
import FadeIn from './FadeIn';

const WhyTour = () => {
  return (
    <section className="py-24 md:py-32 bg-white px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          <FadeIn>
            <h2 className="font-serif text-3xl md:text-5xl text-brand-charcoal mb-6 font-light">Why Couples Tour Padua First</h2>
            <p className="font-sans text-brand-charcoal/80 text-lg leading-relaxed font-light">
              Some venues look good in photos. Padua is different because the property makes more sense when you walk it. The ceremony spaces, terrace views, historic ballroom, olive grove, and catering flow all work together to create a celebration that feels private, warm, and intentional.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}

export default WhyTour;